module.exports = __webpack_public_path__ + "img/heart.65f45349.svg";